import _ from 'lodash';
import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').ChatMessage} ChatMessage
 * @typedef {import('./state').ChatRoom} ChatRoom
 */

/**
 * @param {State} state
 * @param {import('rxjs').Subscription} obj
 */
export function setRoomsSub (state, obj) {
  if (state.roomsSub) state.roomsSub.unsubscribe();
  state.roomsSub = obj || null;

  // reset store
  if (!state.roomsSub) {
    state.rooms = [];
    state.messages = {};
    if (state.messagesSub) state.messagesSub.unsubscribe();
    state.messagesSub = null;
  }
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {string} obj.currentUser uid of current user
 * @param {ChatRoom} obj.item
 */
export function updateInRooms (state, obj) {
  let { item, upsert } = obj;
  item = { ...item };
  item.participants = item.participantsPopulated;
  item.unseenMessages = _.get(item.unseenMessages, state.currentUserUid) || 0;

  // find existing
  const list = state.rooms;
  const index = list.findIndex(i => i.id === item.id);

  // update existing (inherit patient details)
  if (~index) {
    return Vue.set(list, index, item);
  }

  // add to list
  if (upsert) {
    list.push(item);
    Vue.set(state.messages, item.id, [ item.lastMessage ].filter(Boolean));
  }
}

/**
 * @param {State} state
 * @param {import('rxjs').Subscription} obj
 */
export function setMessagesSub (state, obj) {
  if (state.messagesSub) state.messagesSub.unsubscribe();
  state.messagesSub = obj || null;
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {ChatMessage} obj.item
 * @param {boolean} [obj.upsert=true]
 * @param {boolean} [obj.equalityCheck]
 */
export function updateInMessages (state, obj) {
  const { item, upsert, equalityCheck } = obj;
  const list = state.messages[item.room];

  // discard if room is not yet in cache
  if (!list) return;

  // find existing
  const index = list.findIndex(i => equalityCheck ? i === item : i.id === item.id);

  // update existing (inherit patient details)
  if (~index) return Vue.set(list, index, item);

  // add to list
  if (upsert) list.push(item);
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {ChatMessage} obj.item
 * @param {boolean} [obj.equalityCheck]
 */
export function removeInMessages (state, obj) {
  const { item, equalityCheck } = obj;
  const list = state.messages[item.room];

  // discard if room is not yet in cache
  if (!list) return;

  state.messages[item.room] = list.filter(i => equalityCheck ? i !== item : i.id !== item.id);
}
